module.exports = {
          srcSet: __webpack_public_path__ + "91abc087c30ab7db349ec074fd41f1dc-90.png"+" 90w",
          images:[ {path: __webpack_public_path__ + "91abc087c30ab7db349ec074fd41f1dc-90.png",width: 90,height: 25}],
          src: __webpack_public_path__ + "91abc087c30ab7db349ec074fd41f1dc-90.png",
          toString:function(){return __webpack_public_path__ + "91abc087c30ab7db349ec074fd41f1dc-90.png"},
          
          width: 90,
          height: 25
        }